module.exports = __webpack_public_path__ + "img/25.40467d8d.jpg";